import { useState, createContext, useContext, useEffect } from "react";
import AppContext from "./app-context";

const AppProvidor = ({ children }: any) => {
  const [token, setToken] = useState("");
  const [refreshToken, setRefreshToken] = useState("");
  const [user, setUser] = useState({});
  const [theme, setTheme] = useState("light");
  const [propertyTypeDescription, setPropertyTypeDescription] = useState("");
  const [propertyId, setPropertyId] = useState("");

  useEffect(() => {
    const user = JSON.parse(sessionStorage.getItem("user") as string);
    const token = sessionStorage.getItem("token") as string;
    const refToken = sessionStorage.getItem("refreshToken") as string;
    const propertyTypeDescription = sessionStorage.getItem(
      "propertyTypeDescription",
    ) as string;
    const propertyId = sessionStorage.getItem("propertyId") as string;

    setUser(user);
    setToken(token);
    setRefreshToken(refToken);
    setPropertyTypeDescription(propertyTypeDescription);
    setPropertyId(propertyId);
  }, []);

  return (
    <AppContext.Provider
      value={{
        token,
        setToken,
        refreshToken,
        setRefreshToken,
        user: { userRoleId: "", image: "", id: "", ...user },
        setUser,
        theme,
        setTheme,
        propertyTypeDescription,
        setPropertyTypeDescription,
        propertyId,
        setPropertyId,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export default AppProvidor;
